// **  Initial State
const initialState = {
	services: {
		office: {hasOffice: false, belongToOffice: false, hasOfficePendingRequest: false}
	}
}

export const dashboardReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'DASHBOARD_SET_INFO':
			return {
				...state,
				services: action.data.services
			}
		default:
			return state
	}
}
